import { useEffect, useState } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faNewspaper } from '@fortawesome/free-solid-svg-icons'
import { Fade, Slide } from 'react-awesome-reveal'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import axios from 'axios'
import { RotatingLines } from 'react-loader-spinner'
import '../../styles/Admin/Admin.css'
import InputSwitch from '../Input/InputSwitch'
import AdminHome from './AdminHome'
import AdminActuality from './AdminActuality'

function Admin({ ip }) {

    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(true)
    const userInfo = useSelector((state) => state.userReducer)
    const [adminRouter, setAdminRouter] = useState('home')

    useEffect(() => {

        signInVerification()

        // eslint-disable-next-line
    }, [])

    function signInVerification() {

        if (userInfo.tokenJWT) {
            axios.get(process.env.REACT_APP_API_URL + 'user/signInVerification', {
                params: {
                    tokenJWT: userInfo.tokenJWT,
                }
            }).then((response) => {
                if (response.data === "SIGNIN_VERIFIED") {
                    setIsLoading(false)
                }
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_TOKENJWT") {
                        errorMessage = "Erreur lors de la connexion (tokenJWT)"
                    }
                }
                toast.error("Accès non autorisé")
                navigate('/administration/connexion')
            })
        } else {
            toast.error("Accès non autorisé")
            navigate('/administration/connexion')
        }

    }

    if (isLoading) {

        <Fade duration={500}>
            <div className='loader'>
                <RotatingLines
                    strokeColor={"#5b7c18"}
                    strokeWidth={"5"}
                    animationDuration={"1"}
                    width={"40"}
                    visible={true}
                />
            </div>
        </Fade>

    } else {

        return (

            <>
                <BrowserView>
                    <div className='admin'>
                        <div className='adminBarLinkContainer'>
                            <div className='adminBarLink'>
                                <InputSwitch
                                    type={'dark'}
                                    data={[
                                        { label: <FontAwesomeIcon icon={faHome} className='adminBarLinkIcon' />, value: 'home' },
                                        { label: <FontAwesomeIcon icon={faNewspaper} className='adminBarLinkIcon' />, value: 'actuality' }
                                    ]}
                                    value={adminRouter}
                                    setValue={(value) => { setAdminRouter(value) }}
                                    onChange={() => null}
                                />
                            </div>
                        </div>
                        {adminRouter === 'home' ?
                            <Slide direction={'left'} duration={500}>
                                <AdminHome />
                            </Slide>
                            : null
                        }
                        {adminRouter === 'actuality' ?
                            <Slide direction={'right'} duration={500}>
                                <AdminActuality />
                            </Slide>
                            : null
                        }
                    </div>
                </BrowserView>

                <MobileView>
                    <div className='admin'>
                        <div className='adminBarLinkContainer'>
                            <div className='adminBarLinkMobile'>
                                <InputSwitch
                                    type={'dark'}
                                    data={[
                                        { label: <FontAwesomeIcon icon={faHome} className='adminBarLinkIcon' />, value: 'home' },
                                        { label: <FontAwesomeIcon icon={faNewspaper} className='adminBarLinkIcon' />, value: 'actuality' }
                                    ]}
                                    value={adminRouter}
                                    setValue={(value) => { setAdminRouter(value) }}
                                    onChange={() => null}
                                />
                            </div>
                        </div>
                        {adminRouter === 'home' ?
                            <Slide direction={'left'} duration={500}>
                                <AdminHome />
                            </Slide>
                            : null
                        }
                        {adminRouter === 'actuality' ?
                            <Slide direction={'right'} duration={500}>
                                <AdminActuality />
                            </Slide>
                            : null
                        }
                    </div>
                </MobileView>
            </>

        )

    }

}

export default Admin
